import { ref } from "vue";
import { useBrand } from "@/hooks/common/useUtils";

// 区号配置文件路径（位于 public 目录，构建后原样发布，可线上直接修改）
const AREA_CODES_CONFIG_PATH = "config/phone-area-codes.json";

// 模块级缓存，避免多个组件重复请求
let configPromise = null;

const fetchAreaCodesConfig = () => {
  if (!configPromise) {
    const base = process.env.BASE_URL || "/";
    // 加时间戳避免 CDN/浏览器缓存，保证线上修改配置后立即生效
    configPromise = fetch(`${base}${AREA_CODES_CONFIG_PATH}?t=${Date.now()}`)
      .then((res) => (res.ok ? res.json() : null))
      .catch((e) => {
        console.error("fetch phone area codes config error", e);
        return null;
      });
  }
  return configPromise;
};

// 获取当前站点，如 us、uk、th 等
const getSite = () => {
  const { originalSite, site } = document.body?.dataset || {};
  return (originalSite || site || "us").toLowerCase();
};

/**
 * 读取线上区号配置，按 brand[site] 取对应区号列表
 * 配置结构：{ [brand]: { [site]: { areaCodes: string[] }, default: { areaCodes: string[] } } }
 */
export const usePhoneAreaCodes = () => {
  const areaCodes = ref([]);
  const loaded = ref(false);

  const load = async () => {
    const conf = await fetchAreaCodesConfig();
    const brand = useBrand();
    const site = getSite();
    const brandConf = conf?.[brand] || {};
    // 通过 brand[site] 访问指定配置，找不到时回退到该品牌的 default
    const siteConf = brandConf[site] || brandConf.default || {};
    areaCodes.value = Array.isArray(siteConf.areaCodes) ? siteConf.areaCodes : [];
    loaded.value = true;

    console.log('usePhoneAreaCodes',brandConf,brandConf[site],areaCodes.value)
    return areaCodes.value;
  };

  return { areaCodes, loaded, load };
};
